<script setup lang="ts">
import { localize } from "@/utils";
</script>

<template>
  <div id="ct" class="flex-layout-body">
    <div class="grid">
      <div class="grid-side">
        <router-link to="../membership" class="btn-back"
          ><i class="icon icon-back">{{ localize("뒤로") }}</i></router-link
        >
        <h2 class="fs-1">Member<br />Information</h2>
        <u class="text-muted">Anything else?</u>
        <img src="@/assets/playground/img/membership.png" alt="" />
      </div>
      <div class="grid-content">
        <div class="row h-100">
          <div class="col-6">
            <div class="box box-shadow flex-column">
              <h3 class="fs-3 pb-3 mb-4 font-poppins">Personal Information</h3>
              <div class="fieldset info-fieldset">
                <h4>Name</h4>
                <div class="flex-fill">Hyocheol Park <span class="badge bg-primary">Hospital</span></div>
              </div>
              <div class="fieldset info-fieldset">
                <h4>Birth</h4>
                <div class="flex-fill">1900-00-00</div>
              </div>
              <div class="fieldset info-fieldset">
                <h4>Sexual</h4>
                <div class="flex-fill">Male</div>
              </div>
              <div class="fieldset info-fieldset">
                <h4>Nationality</h4>
                <div class="flex-fill">Korea Republic</div>
              </div>
              <div class="fieldset info-fieldset">
                <h4>Cell Phone</h4>
                <div class="flex-fill">+82-10-0000-0000</div>
              </div>
              <div class="fieldset btn-wrap">
                <a href="" class="btn btn-lg">Modify</a>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="box box-shadow flex-column">
              <h3 class="fs-3 pb-3 mb-4 font-poppins">Office Information</h3>

              <!-- 등록 정보 없음 -->
              <div v-if="false" class="empty">
                <p>{{ localize("아직 등록된 정보가 없습니다.") }}</p>
                <div class="btn-wrap">
                  <a href="" class="btn btn-lg">Register</a>
                </div>
              </div>
              <!-- //등록 정보 없음 -->
              <!-- 등록 정보 있음 -->
              <div v-else>
                <div class="fieldset info-fieldset">
                  <h4>Name</h4>
                  <div class="flex-fill">Megagen Dental Clinic</div>
                </div>
                <div class="fieldset info-fieldset">
                  <h4>Cell Phone</h4>
                  <div class="flex-fill">+82-10-0000-0000</div>
                </div>
                <div class="fieldset info-fieldset">
                  <h4>Address</h4>
                  <div class="flex-fill">
                    MegaGEN Tower 13F, Gamasotgol-gil 39-42 Gyeongbok-daero, Jinjeon-eup Namyangju-si, Gyeongi-do
                  </div>
                </div>
                <div class="fieldset btn-wrap">
                  <a href="" class="btn btn-lg">Modify</a>
                </div>
              </div>
              <!-- //등록 정보 있음 -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
